import { webdav } from '../deps.js'
import * as tokens from '../auth/tokens.js'

/**
 * Create a WebDAV client authenticated with a user-signed Bearer token
 * (createUserToken → kid + sub:userId in the payload, verified server-side
 * against the user's registered per-device key).
 *
 * This is the blessed client for servers using the user/chain token system.
 *
 * @param {Object} [options]
 * @param {Object} [options.payload] - Extra claims to include in the token
 * @param {number} [options.expiresIn] - Token lifetime in seconds from now;
 *   omit for a non-expiring token (matches session cookie semantics)
 * @returns {Promise<Object>} webdav client rooted at '/'
 */
async function createAcequiaUserClient({ payload = {}, expiresIn } = {}) {
    let client = webdav.createClient('/', {
        authType: webdav.AuthType.Token,
        token: {
            token_type: 'Bearer',
            access_token: await tokens.createUserToken(payload, expiresIn),
        },
    })

    return client
}

export { webdav, createAcequiaUserClient }
